/* ============================================================
   PRINTHIA LANDING — lp-scripts.js
   Vanilla ES6+, single IIFE, zero dependencies
   ============================================================ */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  var LS = window.localStorage;

  /* ---------- 1. (odstránené — statický badge v HTML) ---------- */

  /* ---------- 2. 3D tilt on product cards ---------- */
  function initTilt() {
    if (isTouch || prefersReducedMotion) return;
    var cards = document.querySelectorAll('.product-card');
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var cx = rect.width / 2;
        var cy = rect.height / 2;
        var rx = ((y - cy) / cy) * -8;
        var ry = ((x - cx) / cx) * 8;
        card.style.transform = 'perspective(1000px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  /* ---------- 3. IntersectionObserver reveal ---------- */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.animate-on-scroll').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.animate-on-scroll').forEach(function (el) { io.observe(el); });
  }

  /* ---------- 4. SVG stroke draw + 5. connector line (handled via CSS when .is-visible) ---------- */

  /* ---------- 6. Countdown timer ---------- */
  function initCountdown() {
    var root = document.querySelector('.js-countdown');
    if (!root) return;
    var target = parseInt(root.getAttribute('data-target'), 10);
    if (!target || isNaN(target)) return;
    var elDays = root.querySelector('.js-cd-days');
    var elHours = root.querySelector('.js-cd-hours');
    var elMins = root.querySelector('.js-cd-mins');
    var elSecs = root.querySelector('.js-cd-secs');
    var expired = document.querySelector('.js-countdown-expired');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var now = Date.now();
      var diff = target - now;
      if (diff <= 0) {
        root.style.display = 'none';
        if (expired) expired.classList.add('is-active');
        clearInterval(timer);
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (elDays)  elDays.textContent  = pad(d);
      if (elHours) elHours.textContent = pad(h);
      if (elMins)  elMins.textContent  = pad(m);
      if (elSecs)  elSecs.textContent  = pad(s);
    }
    tick();
    var timer = setInterval(tick, 1000);
  }

  /* ---------- 7/8/9. Popups ---------- */
  var POPUP_FLAG = 'printhia_popup_shown';
  function showPopup(id) {
    if (LS.getItem(POPUP_FLAG)) return;
    var popup = document.getElementById(id);
    if (!popup) return;
    popup.classList.add('is-open');
    LS.setItem(POPUP_FLAG, '1');
  }
  function initEntryPopup() {
    if (LS.getItem(POPUP_FLAG)) return;
    setTimeout(function () { showPopup('lp-popup-entry'); }, 4000);
  }
  function initExitIntent() {
    if (LS.getItem(POPUP_FLAG)) return;
    document.addEventListener('mouseleave', function handler(e) {
      if (e.clientY <= 0) {
        showPopup('lp-popup-exit');
        document.removeEventListener('mouseleave', handler);
      }
    });
  }
  function initPopupClose() {
    document.querySelectorAll('.lp-popup').forEach(function (popup) {
      popup.addEventListener('click', function (e) {
        if (e.target === popup || e.target.matches('.lp-popup__close')) {
          popup.classList.remove('is-open');
          LS.setItem(POPUP_FLAG, '1');
        }
      });
    });
  }

  /* ---------- 10. Notification bar dismiss ---------- */
  var NOTIF_FLAG = 'printhia_notif_dismissed';
  function initNotifBar() {
    var bar = document.querySelector('.lp-notif-bar');
    if (!bar) return;
    if (LS.getItem(NOTIF_FLAG)) { bar.hidden = true; return; }
    var btn = bar.querySelector('.lp-notif-close');
    if (btn) {
      btn.addEventListener('click', function () {
        bar.hidden = true;
        LS.setItem(NOTIF_FLAG, '1');
      });
    }
  }

  /* ---------- 11. Free shipping progress bar ---------- */
  function initShippingBar() {
    var bar = document.querySelector('.js-shipping-bar');
    if (!bar) return;
    var threshold = parseFloat(bar.getAttribute('data-threshold')) || 100;
    var cart = window.printhiaCart || { total_price: 0 };
    var total = (cart.total_price || 0) / 100;
    var remaining = Math.max(0, threshold - total);
    var percent = Math.min(100, (total / threshold) * 100);
    var fill = bar.querySelector('.progress-bar__fill');
    var label = bar.querySelector('.js-shipping-remaining');
    if (fill) fill.style.setProperty('--progress', percent + '%');
    if (label) label.textContent = remaining.toFixed(2).replace('.', ',');
  }

  /* ---------- 12. Testimonials carousel ---------- */
  function initTestimonials() {
    var stage = document.querySelector('.lp-testimonials__stage');
    if (!stage) return;
    var cards = stage.querySelectorAll('.testimonial-card');
    var dots = document.querySelectorAll('.lp-testimonials__dot');
    if (cards.length < 2) return;
    var idx = 0;
    function go(i) {
      cards.forEach(function (c, j) { c.classList.toggle('is-active', j === i); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      idx = i;
    }
    go(0);
    var timer = setInterval(function () { go((idx + 1) % cards.length); }, 15000);
    stage.addEventListener('mouseenter', function () { clearInterval(timer); });
    stage.addEventListener('mouseleave', function () {
      timer = setInterval(function () { go((idx + 1) % cards.length); }, 15000);
    });
    dots.forEach(function (d, j) {
      d.addEventListener('click', function () { go(j); });
    });
  }

  /* ---------- 13. Smooth anchor scroll ---------- */
  function initAnchorScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- 14. Magnetic buttons (follow cursor) ---------- */
  function initMagneticButtons() {
    if (isTouch || prefersReducedMotion) return;
    var sel = [
      'a.button', 'button.button',
      'a[class*="btn"]', 'button[class*="btn"]',
      'a[class*="__btn"]', 'button[class*="__btn"]',
      '.cta-btn', '.config-preview-btn',
      '.lp-section a[href]', '.lp-section button',
      '.lp-hero a[href]', '.lp-hero button',
      '.lp-faq__all a',
      '[data-magnetic]'
    ].join(', ');
    var blockParents = '.product-card, .lp-product-card, .lp-products__card, [class*="card__"], .card-wrapper, .product-thumbnail, .quantity, .quantity__selector, .product-form__quantity, .swatch, .fil-tab, .dotyk-section .btn-option, .pagination, header, .header, footer, .footer, .cart-drawer, .drawer, .modal, .popup, .lp-popup, .quick-add, .lp-faq .faq-item, details, summary, .lp-ticker, .lp-proof-bar, .lp-rich-footer, nav, .lp-nav';
    var seen = new WeakSet();
    document.querySelectorAll(sel).forEach(function (btn) {
      if (seen.has(btn)) return;
      if (btn.closest(blockParents)) return;
      if (btn.hasAttribute('data-no-magnetic')) return;
      var r = btn.getBoundingClientRect();
      if (r.width < 90 || r.height < 28) return;
      seen.add(btn);
      btn.addEventListener('mousemove', function (e) {
        var rr = btn.getBoundingClientRect();
        var dx = (e.clientX - (rr.left + rr.width * 0.5)) * 0.27;
        var dy = (e.clientY - (rr.top + rr.height * 0.5)) * 0.27;
        btn.style.transition = 'transform 0.12s ease-out';
        btn.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transition = 'transform 0.55s cubic-bezier(0.23,1,0.32,1)';
        btn.style.transform = '';
      });
    });
  }

  /* ---------- 15. Hero spotlight (cursor-following glow) ---------- */
  function initHeroSpotlight() {
    if (isTouch || prefersReducedMotion) return;
    var hero = document.querySelector('.lp-hero');
    if (!hero) return;
    if (getComputedStyle(hero).position === 'static') hero.style.position = 'relative';
    if (getComputedStyle(hero).overflow !== 'hidden') hero.style.overflow = 'hidden';
    var spot = document.getElementById('lp-hero-spotlight');
    if (!spot) {
      spot = document.createElement('div');
      spot.id = 'lp-hero-spotlight';
      hero.appendChild(spot);
    }
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      spot.style.left = (e.clientX - r.left) + 'px';
      spot.style.top = (e.clientY - r.top) + 'px';
      spot.style.opacity = '1';
    });
    hero.addEventListener('mouseleave', function () { spot.style.opacity = '0'; });
  }

  /* ---------- 16. Ripple on button click ---------- */
  function initRipple() {
    if (prefersReducedMotion) return;
    document.querySelectorAll('.lp-hero__btn, .lp-cta-final__btn, .lp-nz__btn, .lp-btn, .lp-btn-primary, .lp-btn-secondary, .lp-btn-cta-final').forEach(function (btn) {
      if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.addEventListener('click', function (e) {
        var r = btn.getBoundingClientRect();
        var sz = Math.max(r.width, r.height) * 2.6;
        var el = document.createElement('span');
        el.style.cssText = 'position:absolute;border-radius:50%;pointer-events:none;background:rgba(255,255,255,0.24);width:' + sz + 'px;height:' + sz + 'px;left:' + (e.clientX - r.left - sz / 2) + 'px;top:' + (e.clientY - r.top - sz / 2) + 'px;transform:scale(0);animation:lpRipple 0.65s ease-out forwards;';
        btn.appendChild(el);
        setTimeout(function () { if (el.parentNode) el.remove(); }, 700);
      });
    });
  }

  function injectFxStyles() {
    if (document.getElementById('lp-fx-styles')) return;
    var s = document.createElement('style');
    s.id = 'lp-fx-styles';
    s.textContent = '@keyframes lpRipple{to{transform:scale(3.5);opacity:0}}'
      + '#lp-hero-spotlight{position:absolute;width:520px;height:520px;border-radius:50%;background:rgba(255,95,0,0.13);pointer-events:none;z-index:1;opacity:0;transition:opacity .5s ease;transform:translate(-50%,-50%);will-change:left,top}';
    document.head.appendChild(s);
  }

  /* ---------- boot ---------- */
  function boot() {
    document.body.classList.add('js-enabled');
    injectFxStyles();
    initTilt();
    initScrollReveal();
    initCountdown();
    initEntryPopup();
    initExitIntent();
    initPopupClose();
    initNotifBar();
    initShippingBar();
    initTestimonials();
    initAnchorScroll();
    initMagneticButtons();
    initHeroSpotlight();
    initRipple();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
